<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">

      <m-confirm ref="confirm"></m-confirm>
      <m-invoice :dialog="dialog_invoice" :selectedItem="selectedItem" :filteredBookings="filteredBookings" :start="date_start" :end="date_end" @close="onClose"></m-invoice>

      <v-card-title class="m-page__title">
        <span class="headline">Archived Insurances Invoices</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
         Total: {{ totalAmount | currency(true) }}
         <m-csv-btn :disabled="items.length === 0" :data="csvItems" filename="invoices_insurances_archived.csv" separator-excel></m-csv-btn>
      </v-card-title>

            <v-spacer></v-spacer>
            <v-layout wrap grid-list-md>

                    <v-flex xs12 class="px-1">
                    <v-card>
                      <v-card-title>
                        <v-toolbar flat class="tm-toolbar">
                              <v-spacer></v-spacer>
                              <v-text-field
                                append-icon="search"
                                label="Search"
                                single-line
                                v-model="search_invoices"
                              ></v-text-field>
                      </v-toolbar>
                      </v-card-title>

                      <v-data-table
                          v-bind:headers="headers_invoices"
                          v-bind:items="filteredItems"
                          :options.sync="pagination_invoices"
                          :sort-by="['date']"
                          :sort-desc="[true]"
                          :footer-props="{ 'items-per-page-options': [20, 50, {text:'All', value:-1}] }"
                        >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id" :class="'status-' + item.status">
                          <td >{{ item.id }}</td>
                          <td >{{ item.date | date }}</td>
                          <td >{{ item.name }}</td>
                          <td >{{ item.clientId }}</td>
                          <td >{{ item.amount | currency }}</td>
                          <td v-if="can('invoicing')">
                          <v-menu>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" text @click.prevent class="status" :class="'status-' + item.status">
                              {{ item.status | formatIndex(modes) }}
                            </v-btn>
                            </template>
                            <v-list>
                              <v-list-item v-for="state in status" :key="state.value" @click.prevent="onStatusChange(item, state.value)">
                                <v-list-item-title :class="{ 'primary--text': item.status === state.value }">{{ state.text }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          </td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="onSelect(item)">
                              <v-icon color="primary">visibility</v-icon>
                            </v-btn>
                          </td>
                            </tr>
                          </tbody>
                        </template>
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                          From {{ pageStart }} to {{ pageStop }}
                        </template>
                      </v-data-table>
                  </v-card>
                    </v-flex>

            </v-layout>





      <div style="width:100%">

      </div>
    </div>
	</m-layout>
</template>
<script>
import Confirm from '@/components/confirm.vue'
import Invoice from '@/components/wallet/insurance.vue'
import { searchItems } from '@/utils/helpers'
import CSVMixin from '@/mixins/CSVMixin'
import AuthMixin from '@/mixins/auth'
import moment from 'moment';
export default {
  name: 'wallet',
  mixins: [AuthMixin, CSVMixin],
  components: {
    'm-confirm': Confirm,
    'm-invoice': Invoice
  },
  data () {
    return {
      dialog_invoice: false,
      menu_date_start: false,
      date_start: moment().startOf('month').format('YYYY-MM-DD'),
      date_end: moment().endOf('month').format('YYYY-MM-DD'),
      menu_date_end: false,
      dateFormatted_start: null,
      dateFormatted_end: null,
      currentMonth: moment().format('MMMM YYYY'),
      search: '',
      search_invoices: '',
      factuurType: null,
      pagination: {},
      pagination_invoices: {},
      form: {},
      modes: ['pending', 'close', 'overdue'],
      status: [
        {text: 'pending', value: 0},
        {text: 'close', value: 1},
        {text: 'overdue', value: 2}
      ],
      headers_invoices: [
        { text: 'ID', value: 'id' },
        { text: 'Date', value: 'date' },
        { text: 'Name', value: 'name' },
        { text: 'Client ID', value: 'clientId' },
        { text: 'Amount', value: 'amount' },
        { text: 'Status', value: 'status' },
        { text: 'Action', value: 'action' }
      ],
      items: [],
      headers_bookings: [
        {
          text: 'ID',
          align: 'left',
          width: '10',
          value: 'id'
        },
        { width: '20', text: '​Date', value: 'ap_date' },
        { width: '20', text: '​Time', value: 'ap_time' },
        { width: '20', text: 'Client', value: 'client_lastname' },
        { width: '30', text: '​Destination', value: 'destination_name' },
        { width: '30', text: 'Type', value: 'type' },
        { text: 'Price', value: 'price' },
        { text: 'Wait price', value: 'waitprice' },
        { text: 'Wait time', value: 'ap_waittime' },
        { width: '10', text: 'Duration', value: 'duration' },
        { width: '10', text: 'Distance', value: 'dist' },
        { text: 'Factuur', value: 'factuur' }

      ],
      bookings: [],
      selectedItem: {}
    }
  },
  methods: {
    tableFilter (items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter(row => filter(row['facture'], search));
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onRefresh () {
      this.getData();
    },
    onChangeDate () {
      console.log('onChangeDate: ', this.date_start, this.date_end);
      // this.getDataByDate(this.date_start, this.date_end);
      this.menu_date_start = this.menu_date_end = false;
    },
    onSelect (item) {
      var app = this;
      this.getBookingsByInsuranceInvoice(item).then(function () {
        app.onFactuurItem(item);
      });
    },
    onStatusChange (item, value) {
      item.status = value;
      console.log('onStatusChange', item.id);
      this.updateStatusForm(item);
    },
    onFactuurItem (item) {
      this.selectedItem = item;
      this.dialog_invoice = true;
    },
    onClose () {
      this.dialog_invoice = false;
    },
    getData () {
      this.$http
      .get('service/invoice/insuranceArchived')
      .then(response => {
        console.log('archived invoices response', response.data);
        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    updateStatusForm (data) {
      var obj = {
        status: data.status
      };
      console.log('updateBooking: ', obj);

      this.$http
      .post('service/invoice/insurancesUpdate/' + data.id, obj)
      .then(response => {
        console.log('updateStatusForm response ', response.data);
        this.getData();
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getBookingsByInsuranceInvoice (item) {
      var app = this;
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/invoice/bookingsByInsuranceInvoice', {
          invoiceId: item.id,
          insuranceId: item.insuranceId
          // invoiceId: invoiceId
        })
        .then(response => {
          console.log('invoice bookings response', response.data);
          app.bookings = response.data;
          app.bookings.map(function (d) {
            var distance = d.json = JSON.parse(d.distance)
            d.ap_date = app.$options.filters.date(d.ap_date)
            d.price = d.price || distance.totals[d.type].price
            d.dist = distance.totals[d.type].distance
            d.duration = app.$options.filters.toTime(distance.totals[d.type].duration)
          });
          resolve(item);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    }
  },
  computed: {
    filteredBookings () {
      return this.bookings.filter((i) => {
        console.log('filter ', i.factuur, this.factuurType);
        return this.factuurType === null || (i.factuur === this.factuurType);
      })
    },
    filteredItems () {
      return searchItems(this.items, this.search_invoices);
    },
    totalAmount () {
      return this.filteredItems.reduce((sum, a) => sum + Number(a.amount), 0);
    }
  },
  created () {
    this.getData();
  }
}
</script>
<style lang="scss">
  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2 {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}

.v-btn.status {
  text-transform: none;
  color: grey;
  &-1 {
    color:rgba(32, 151, 2, 1) !important;
  }
  &-2 {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>
